import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getArticles } from '@/lib/articlesApi';
import { InterviewMapperService } from '@/services/interview/management/base/interviewMapperService';

export const usePaginatedPublishHistory = (itemsPerPage: number = 50) => {
  const [page, setPage] = useState(1);
  
  console.log('[usePaginatedPublishHistory] Current state:', { page, itemsPerPage });
  
  const {
    data: publishedInterviews,
    isLoading,
    error
  } = useQuery({
    queryKey: ['interviews', 'published', 'paginated', page, itemsPerPage],
    queryFn: async () => {
      const offset = (page - 1) * itemsPerPage;
      console.log('[usePaginatedPublishHistory] Fetching with:', { limit: itemsPerPage, offset });
      const data = await getArticles({ 
        limit: itemsPerPage, 
        offset 
      });
      
      if (!data || !Array.isArray(data)) {
        return [];
      }
      
      console.log('[usePaginatedPublishHistory] Received articles:', data.length);
      
      return data.map(interview => 
        InterviewMapperService.mapDatabaseInterviewToModel(interview as any)
      );
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return {
    publishedInterviews,
    isLoading,
    error,
    page,
    setPage,
    itemsPerPage
  };
};
